/**
 * Feature flags: flip when ready to monetize.
 * Payments off by default: full report is free with premium presentation.
 */
export const isPaymentsEnabled = () =>
  process.env.REACT_APP_PAYMENTS_ENABLED === 'true';

/** When payments are off, everyone gets the full report. */
export const hasFullReportAccess = (hasPaidAccess = false) =>
  !isPaymentsEnabled() || hasPaidAccess;
